<template>
 <div id="btn_foot" class="mob">
   <span>点击按钮立即报名</span>
   <span class="glyphicon glyphicon-arrow-right"></span>
   <a href="/order?sid=2691">
     <div class="orderbtn shanghai">上海站</div>
   </a>
   <!-- <a href="/order?sid=2690">
     <div class="orderbtn tianjin">天津站</div>
   </a> -->
   <a href="/order?sid=2721">
     <div class="orderbtn beijing">北京站</div>
   </a>
 </div>
</template>

<script>
export default {
  name: 'ButtonFoot',
  data () {
    return {
      sid: '',
      place: ''
    }
  },
  methods: { }
}
</script>

<style>
/* #btn_foot {
  position: fixed;
  margin-bottom: 0;
  width: 100%;
  height: 50px;
  background: rgba(255, 255, 0, 0.5);
} */
</style>



// WEBPACK FOOTER //
// src/components/ButtonFoot.vue